// Google Analytics 4 + Meta Pixel tracking utilities

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}

let gaInitialized = false;
let fbInitialized = false;

export function initGA(measurementId: string) {
  if (gaInitialized || !measurementId) return;
  gaInitialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: true });
}

export function initMetaPixel(pixelId: string) {
  if (fbInitialized || !pixelId) return;
  fbInitialized = true;

  /* Meta Pixel base code */
  const n = (window.fbq = function () {
    // @ts-ignore
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  } as any);
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

// ── Event helpers ──

interface ProductInfo {
  id: string;
  name: string;
  price: number;
  quantity: number;
}

export function trackAddToCart(product: ProductInfo, currency = "BRL") {
  if (window.gtag) {
    window.gtag("event", "add_to_cart", {
      currency,
      value: product.price * product.quantity,
      items: [
        {
          item_id: product.id,
          item_name: product.name,
          price: product.price,
          quantity: product.quantity,
        },
      ],
    });
  }
  if (window.fbq) {
    window.fbq("track", "AddToCart", {
      content_ids: [product.id],
      content_name: product.name,
      content_type: "product",
      value: product.price * product.quantity,
      currency,
    });
  }
}

export function trackViewContent(product: ProductInfo, currency = "BRL") {
  if (window.gtag) {
    window.gtag("event", "view_item", {
      currency,
      value: product.price,
      items: [{ item_id: product.id, item_name: product.name, price: product.price }],
    });
  }
  if (window.fbq) {
    window.fbq("track", "ViewContent", {
      content_ids: [product.id],
      content_name: product.name,
      content_type: "product",
      value: product.price,
      currency,
    });
  }
}

export function trackBeginCheckout(items: ProductInfo[], total: number, currency = "BRL") {
  if (window.gtag) {
    window.gtag("event", "begin_checkout", {
      currency,
      value: total,
      items: items.map((i) => ({
        item_id: i.id,
        item_name: i.name,
        price: i.price,
        quantity: i.quantity,
      })),
    });
  }
  if (window.fbq) {
    window.fbq("track", "InitiateCheckout", {
      content_ids: items.map((i) => i.id),
      num_items: items.length,
      value: total,
      currency,
    });
  }
}

export function trackPurchase(
  orderId: string,
  items: ProductInfo[],
  total: number,
  currency = "BRL"
) {
  if (window.gtag) {
    window.gtag("event", "purchase", {
      transaction_id: orderId,
      currency,
      value: total,
      items: items.map((i) => ({
        item_id: i.id,
        item_name: i.name,
        price: i.price,
        quantity: i.quantity,
      })),
    });
  }
  if (window.fbq) {
    window.fbq("track", "Purchase", {
      content_ids: items.map((i) => i.id),
      content_type: "product",
      num_items: items.length,
      value: total,
      currency,
    });
  }
}
